import React, { createContext, memo } from "react";
import { FormGroup as BootstrapFormGroup } from "react-bootstrap";
import styled, { css } from "styled-components";
import chroma from "chroma-js";
import { CONTROL_CLASS as COMMON_SELECT_CONTROL_CLASS } from "components/common/Select/index";
import FormControl from "./FormControl";
import { StyledAddon } from "./InputGroup";
const StyledFormGroup = styled(BootstrapFormGroup)(({ theme, validationState }) => {
  const variant = validationState === "error" ? "danger" : validationState;
  if (!variant) {
    return void 0;
  }
  const text = theme.colors.variant.dark[variant];
  const border = theme.colors.variant.light[variant];
  const background = theme.colors.variant.lightest[variant];
  return css`
    &.has-${validationState} {
      .help-block,
      .control-label,
      .radio,
      .checkbox,
      .radio-inline,
      .checkbox-inline,
      &.radio label,
      &.checkbox label,
      &.radio-inline label,
      &.checkbox-inline label {
        color: ${text};
      }

      ${FormControl}, .${COMMON_SELECT_CONTROL_CLASS} {
        border-color: ${border};

        &:focus {
          border-color: ${chroma(border).darken(0.1).toString()};
          box-shadow:
            inset 0 1px 1px rgb(0 0 0 / 7.5%),
            0 0 6px ${chroma(border).brighten(0.2).toString()};
        }
      }

      ${StyledAddon} {
        color: ${text};
        background-color: ${background};
        border-color: ${border};
      }

      .form-control-feedback {
        color: ${text};
      }
    }
  `;
});
export const FormGroupControlIdContext = createContext(void 0);
const FormGroup = ({ children = void 0, validationState = null, controlId, ...props }) => /* @__PURE__ */ React.createElement(FormGroupControlIdContext.Provider, { value: controlId }, /* @__PURE__ */ React.createElement(StyledFormGroup, { validationState, controlId, ...props }, children));
export default memo(FormGroup);
